import {
  allAvailableEventTypes,
  platformOptions,
  VISIT_EVENT_TYPES,
  VISIT_EVENT_TYPES_ARRAY,
} from 'src/consumer/constants'
import { SuggestedAssessmentsSelectMenu } from 'src/mentor/components/PrescriptionMakingPage/PrescriptionMakingPageComponents'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'
import {
  GenericModalHeadlineLevelTwo,
  StyledInputSelect,
} from 'src/mentor/components/MentorAvailabilityPage/MentorAvailabilityPageStyles'

export default function EventTypeConfiguration({
  basicEventObject,
  setBasicEventObject,
  displayNamesOfEventTypes,
  mentorProfileData,
  forceShowDoctorEventTypes,
  forceShowTherapistEventTypes,
  changeLocationBasedOnMentorOrClinicLocation,
  isDisabled,
}) {
  return (
    <>
      {basicEventObject?.type !== allAvailableEventTypes?.webinar && (
        <div>
          <GenericModalHeadlineLevelTwo>Type</GenericModalHeadlineLevelTwo>
          <StyledInputSelect
            value={basicEventObject?.type}
            onChange={(e) =>
              setBasicEventObject((prev) => ({
                ...prev,
                type: e.target.value,
                visitEventType: VISIT_EVENT_TYPES.regular,
              }))
            }
            disabled={isDisabled}
          >
            <option value={allAvailableEventTypes.oneOnOne}>
              {displayNamesOfEventTypes?.[allAvailableEventTypes.oneOnOne]}
            </option>
            <option value={allAvailableEventTypes.screening}>
              {displayNamesOfEventTypes?.[allAvailableEventTypes.screening]}
            </option>
            <option value={allAvailableEventTypes.interview}>
              {displayNamesOfEventTypes?.[allAvailableEventTypes.interview]}
            </option>
            {((mentorProfileData?.allowedToPrescribe && getAllRolesInBoolean().isDoctor) ||
              forceShowDoctorEventTypes) && (
              <option value={allAvailableEventTypes.consultation}>
                {displayNamesOfEventTypes?.[allAvailableEventTypes.consultation]}
              </option>
            )}
            {(mentorProfileData?.services?.live || forceShowTherapistEventTypes) && (
              <>
                <option value={allAvailableEventTypes.therapySession}>
                  {displayNamesOfEventTypes?.[allAvailableEventTypes.therapySession]}
                </option>
                <option value={allAvailableEventTypes.assessment}>
                  {displayNamesOfEventTypes?.[allAvailableEventTypes.assessment]}
                </option>
              </>
            )}
          </StyledInputSelect>
        </div>
      )}

      {basicEventObject?.type === allAvailableEventTypes.screening && (
        <div>
          Note: Screening events should be offline and associated to a clinic. Patients in clinic
          can opt to go through this step before consulting a psychiatrist.
        </div>
      )}

      {basicEventObject?.type === allAvailableEventTypes.consultation && (
        <div>
          <GenericModalHeadlineLevelTwo>Event Visit Type</GenericModalHeadlineLevelTwo>
          <StyledInputSelect
            value={basicEventObject?.visitEventType || ''}
            onChange={(e) => {
              setBasicEventObject((prev) => ({ ...prev, visitEventType: e.target.value }))
            }}
            disabled={isDisabled}
          >
            <option value="" hidden>
              None
            </option>
            {VISIT_EVENT_TYPES_ARRAY?.map((item, index) => {
              return (
                <option key={item?.id} value={item?.id}>
                  {item?.title}
                </option>
              )
            })}
          </StyledInputSelect>
        </div>
      )}

      {basicEventObject?.type === allAvailableEventTypes.assessment && (
        <SuggestedAssessmentsSelectMenu
          isNotCreatable
          selectedAssessments={basicEventObject?.psychAssessmentIds}
          setSelectedAssessments={(value) => {
            setBasicEventObject((prev) => ({ ...prev, psychAssessmentIds: value }))
          }}
          searchApiSignature={`/api/secure/teacher/psych-assessment/search`}
          customPlaceholder="Search assessments to attach to this event..."
          doctorSpecializations={mentorProfileData?.specializedCategories}
          disabled={isDisabled}
        />
      )}

      <div>
        <GenericModalHeadlineLevelTwo>Meeting Source(Platform)</GenericModalHeadlineLevelTwo>
        <StyledInputSelect
          value={basicEventObject?.meetingSrc}
          onChange={(e) => {
            setBasicEventObject((prev) => ({ ...prev, meetingSrc: e.target.value }))
            changeLocationBasedOnMentorOrClinicLocation(
              basicEventObject?.location,
              basicEventObject?.contextId,
            )
          }}
          disabled={isDisabled}
        >
          {platformOptions?.map((item, index) => {
            return (
              <option key={item?.id} value={item?.id}>
                {item?.name}
              </option>
            )
          })}
        </StyledInputSelect>
      </div>
    </>
  )
}
